'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useCallback } from 'react';
import { CmsPageTakeover } from '@spa/top-level-components/cms-page/CmsComponentPage';
import TakeoverFrameComponent from './takeover-frame.component';
import TakeoverLayerLinkComponent from './takeover-layer-link.component';
import TakeoverPageStylesComponent from './takeover-page-styles.component';
import { useDismissedTakeover } from './useDismissedTakeover';
import { usePathname } from 'next/navigation';
export interface Props {
  readonly takeover: CmsPageTakeover | null;
}
function focusPageContent(): void {
  const main = document.querySelector<HTMLElement>('main, [role="main"]');
  const target = main ?? document.body;
  if (!target.hasAttribute('tabindex')) {
    target.setAttribute('tabindex', '-1');
  }
  target.focus();
}
export default function TakeoverController(t0) {
  const $ = _c(13);
  const {
    takeover
  } = t0;
  const pathname = usePathname();
  const [isDismissed, dismiss] = useDismissedTakeover(pathname);
  let t1;
  if ($[0] !== dismiss) {
    t1 = () => {
      focusPageContent();
      dismiss();
    };
    $[0] = dismiss;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDismiss = t1;
  const activeTakeover = isDismissed ? null : takeover;
  const onDismiss = takeover?.showCancel === true ? handleDismiss : undefined;
  let t2;
  if ($[2] !== activeTakeover) {
    t2 = <TakeoverPageStylesComponent takeover={activeTakeover} />;
    $[2] = activeTakeover;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeTakeover || $[5] !== onDismiss) {
    t3 = <TakeoverFrameComponent takeover={activeTakeover} onDismiss={onDismiss} />;
    $[4] = activeTakeover;
    $[5] = onDismiss;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeTakeover) {
    t4 = <TakeoverLayerLinkComponent takeover={activeTakeover} />;
    $[7] = activeTakeover;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}